import { GET_COUNTRIES_SUCCESS, SET_COUNTRY } from './actions'
import { Country } from '../../global/types'

export type CountriesState = {
  selected: number
  data: Record<number, Country[]>
}

type SetCountries = {
  type: typeof GET_COUNTRIES_SUCCESS
  countries: Country[]
}

type SetCountry = {
  type: typeof SET_COUNTRY
  id: number
}

const initialState: CountriesState = { selected: null, data: {} }

export const reducer = (
  state = initialState,
  action: SetCountries | SetCountry,
) => {
  switch (action.type) {
    case GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        ...{ data: action.countries },
      }

    case SET_COUNTRY:
      return {
        ...state,
        selected: action.id,
      }
    default:
      return state
  }
}
